import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid__cell gfu-1of1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_option_field = _resolveComponent("option-field")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createVNode(_component_base_title, { as: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.SubscriptionManagement.SystemNotificationHeader), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.systemMessages,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => ((_ctx.model.systemMessages) = $event)),
              $options.onSystemMessageNotificationPreferenceChange
            ],
            "first-column-width": 8,
            "read-only": true,
            options: $setup.basePreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.SystemMessagesFieldLabel,
            name: "model.systemMessages",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.SystemMessagesFieldDescription,
            "data-qa": "general-notifications:SystemMessages"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          ($options.isFeastNewsletterEnabled)
            ? (_openBlock(), _createBlock(_component_option_field, {
                key: 0,
                modelValue: _ctx.model.feast,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = $event => ((_ctx.model.feast) = $event)),
                  $options.onFestNotificationPreferenceChange
                ],
                "first-column-width": 8,
                options: $setup.basePreferenceOptions,
                "display-name": _ctx.Resources.SubscriptionManagement.FeastFieldLabel,
                name: "model.feast",
                layout: "columns",
                class: "_mb-3",
                description: _ctx.Resources.SubscriptionManagement.FeastFieldDescription,
                "data-qa": "general-notifications:Feast"
              }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.newsletter,
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = $event => ((_ctx.model.newsletter) = $event)),
              $options.onNewsletterNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $setup.basePreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.NewsletterFieldLabel,
            name: "model.newsletter",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.NewsletterFieldDescription,
            "data-qa": "general-notifications:Newsletter"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.commentReply,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = $event => ((_ctx.model.commentReply) = $event)),
              $options.onCommentReplyNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $setup.notificationPreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.CommentRepliesFieldLabel,
            name: "model.commentReply",
            layout: "columns",
            class: "_mb-3",
            description: _ctx.Resources.SubscriptionManagement.CommentRepliesFieldDescription,
            "data-qa": "general-notifications:CommentReply"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"]),
          _createVNode(_component_option_field, {
            modelValue: _ctx.model.preferredDigestFrequency,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = $event => ((_ctx.model.preferredDigestFrequency) = $event)),
              $options.onDigestFrequencyNotificationPreferenceChange
            ],
            "first-column-width": 8,
            options: $options.digestFrequencyPreferenceOptions,
            "display-name": _ctx.Resources.SubscriptionManagement.CommunityLifeFieldLabel,
            name: "model.preferredDigestFrequency",
            layout: "columns",
            class: "_mt-0",
            description: _ctx.Resources.SubscriptionManagement.CommunityLifeFieldDescription,
            "data-qa": "general-notifications:CommunityLife"
          }, null, 8 /* PROPS */, ["modelValue", "options", "display-name", "description", "onUpdate:modelValue"])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}